import { MultiSelect } from "primereact/multiselect";
import localeText from "../../../../locale";
import FormField from "./FormField";

// Vínculo com subcategorias. `lockedOptions` são vínculos já existentes: a API não permite
// desvincular, então aparecem fixos e ficam fora das opções selecionáveis.
const SubcategoryPicker = ({
  options,
  value,
  onChange,
  lockedOptions = [],
  loading,
  error,
  required,
  hint,
}) => {
  const lockedIds = new Set(lockedOptions.map((option) => option.id));
  const selectable = options.filter((option) => !lockedIds.has(option.id));

  return (
    <FormField
      label={localeText("adminCatalogSubcategories")}
      error={error}
      required={required}
      hint={hint}
    >
      {lockedOptions.length > 0 && (
        <div className="admin-chips" aria-label={localeText("adminCatalogLinkedSubcategories")}>
          {lockedOptions.map((option) => (
            <span key={option.id} className="admin-chip admin-chip--locked">
              <i className="pi pi-link" aria-hidden="true" />
              {option.label}
            </span>
          ))}
        </div>
      )}
      <MultiSelect
        value={value}
        options={selectable}
        optionLabel="label"
        optionValue="id"
        onChange={(e) => onChange(e.value)}
        filter
        display="chip"
        placeholder={localeText(
          lockedOptions.length ? "adminCatalogAddSubcategories" : "adminCatalogChooseSubcategories",
        )}
        emptyFilterMessage={localeText("adminListNoResults")}
        disabled={loading}
        className="admin-multiselect"
        panelClassName="admin-multiselect-panel"
        maxSelectedLabels={50}
      />
    </FormField>
  );
};

export default SubcategoryPicker;
